import useLazyAgathaFetchQuery from "@/search/useLazyAgathaFetchQuery";
import filterRelatedContentCards from "../filterRelatedContentCards";

const useFetchRelatedContentCards = (contentId, contentIsVideo) => {
  const getParams = (contentType) => ({
    content_types: contentType,
    page: 0,
    // Fetch four of each, to allow for the edge case where the other content type doesn't return any results.
    page_size: 4,
    related_to_content_ids: contentId,
    shape: "card",
  });

  const [fetchArticles, { data: { results: articles } = { results: [] } }] =
    useLazyAgathaFetchQuery({
      endpoint: "search",
      queryParameters: getParams("articleheader"),
    });

  const [fetchTextSets, { data: { results: textSets } = { results: [] } }] =
    useLazyAgathaFetchQuery({
      endpoint: "search",
      queryParameters: getParams("textset"),
    });

  const [fetchVideos, { data: { results: videos } = { results: [] } }] =
    useLazyAgathaFetchQuery({
      endpoint: "search",
      queryParameters: getParams("interactivevideolink"),
    });

  const fetchRelatedContentCards = () => {
    if (contentIsVideo) {
      fetchVideos();
    } else {
      fetchArticles();
      fetchTextSets();
    }
  };

  const filteredCards = contentIsVideo
    ? videos
    : filterRelatedContentCards(textSets, articles);

  return [fetchRelatedContentCards, filteredCards];
};

export default useFetchRelatedContentCards;
